export default __webpack_public_path__ + "static/media/ship-2.a9ee6420.png";